exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-form-label[data-v-44bb94c4] {\n    white-space: nowrap;\n}\n", ""]);

// exports
